import { render, staticRenderFns } from "./addSeckill.vue?vue&type=template&id=c77f6e9a&scoped=true&"
import script from "./addSeckill.vue?vue&type=script&lang=js&"
export * from "./addSeckill.vue?vue&type=script&lang=js&"
import style0 from "./addSeckill.vue?vue&type=style&index=0&id=c77f6e9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77f6e9a",
  null
  
)

export default component.exports